import {
    mdiFaceAgent,
    mdiFacebook,
} from '@mdi/js'
import {iconZalo} from '@shared/helpers/icons'
import clsx from 'clsx'
import {IconHref} from 'swayok-react-mdb-ui-kit/components/Icon/IconHref'
import {appUrl} from '../../../../AppUrl'
import {useRegionConfig} from '../../../../hooks'

interface VnContactsExternalLinksProps {
    className?: string
}

// Блок с внешними ссылками на способы связи для футера (Вьетнам).
export function VnContactsExternalLinks(props: VnContactsExternalLinksProps) {

    const {
        className = 'flex-row-center gap-5',
    } = props

    const regionConfig = useRegionConfig()
    return (
        <ul className={clsx('footer-social-links list-unstyled m-0', className)}>
            <li>
                <IconHref
                    path={mdiFaceAgent}
                    href={appUrl().support.askQuestion}
                    className="app-support-link"
                />
            </li>
            {regionConfig.contacts.facebook && (
                <li>
                    <IconHref
                        path={mdiFacebook}
                        href={regionConfig.contacts.facebook}
                        target="_blank"
                        className="facebook-link"
                    />
                </li>
            )}
            {regionConfig.contacts.zalo && (
                <li>
                    <IconHref
                        path={iconZalo}
                        href={regionConfig.contacts.zalo}
                        target="_blank"
                        rel="noreferrer"
                        className="zalo-link"
                        size={{width: 49.5, height: 18}}
                    />
                </li>
            )}
        </ul>
    )
}
